import React, { useMemo, useState, FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'utils/axios';
import './ForgotPassword.css';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get('token') || '', [params]);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!token) {
      setError('Password reset token is missing.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post('/v1/api/reset-password', { token, newPassword });
      setMessage('Password updated successfully. You can now log in.');
      setNewPassword('');
      setConfirmPassword('');
      window.setTimeout(() => navigate('/login'), 1200);
    } catch (err: any) {
      setError(err?.response?.data?.message || err.message || 'Unable to reset password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fp-container">
      <form className="fp-form" onSubmit={handleSubmit}>
        <h2 className="fp-title">Reset Password</h2>
        {message && <div className="fp-alert fp-alert--success">{message}</div>}
        {error && <div className="fp-alert fp-alert--error">{error}</div>}
        <div className="fp-field">
          <label className="fp-label" htmlFor="newPassword">New Password</label>
          <input
            className="fp-input"
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            minLength={8}
            required
          />
        </div>
        <div className="fp-field">
          <label className="fp-label" htmlFor="confirmPassword">Confirm Password</label>
          <input
            className="fp-input"
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            minLength={8}
            required
          />
        </div>
        <button type="submit" className="fp-btn" disabled={submitting}>
          {submitting ? 'Saving...' : 'Update Password'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
